import { render, staticRenderFns } from "./AllOrdingReturn.vue?vue&type=template&id=3aff14fa&scoped=true"
import script from "./AllOrdingReturn.vue?vue&type=script&lang=js"
export * from "./AllOrdingReturn.vue?vue&type=script&lang=js"
import style0 from "./AllOrdingReturn.vue?vue&type=style&index=0&id=3aff14fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff14fa",
  null
  
)

export default component.exports